import { useState } from "react";

const AssignForm = ({ existingEmails, onSend }) => {
    const [email, setEmail] = useState("");
    const [sending, setSending] = useState(false);
    const [error, setError] = useState("");

    const handleSend = async () => {
        const trimmed = email.trim().toLowerCase();
        if (!trimmed) return;

        setError("");

        const alreadyAssigned = existingEmails
            .map((e) => e.toLowerCase())
            .includes(trimmed);

        if (alreadyAssigned) {
            setError("This email already has a license assigned.");
            return;
        }

        setSending(true);
        try {
            await onSend(email.trim());
            // parent handles closing the form + showing confirmation
        } catch (err) {
            console.error("Error assigning license", err);
            setError("Something went wrong. Please try again.");
            setSending(false);
        }
    };

    return (
        <div className="bg-gray-100 rounded-lg p-4 w-full">
            <p className="italic text-center mb-3">Assign to:</p>
            <input
                type="email"
                value={email}
                onChange={(e) => {
                    setEmail(e.target.value);
                    setError("");
                }}
                placeholder="enter email..."
                className="w-full italic text-sm rounded px-3 py-2 mb-3 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600"
            />

            {error && (
                <p className="text-red-500 text-xs text-center mb-3">
                    {error}
                </p>
            )}

            <div className="flex justify-center">
                <button
                    onClick={handleSend}
                    disabled={sending || !email.trim()}
                    className="bg-cyan-700 hover:bg-cyan-800 disabled:bg-cyan-700/50 disabled:cursor-not-allowed text-white font-semibold rounded-full px-6 py-1.5"
                >
                    {sending ? "Sending..." : "send"}
                </button>
            </div>
        </div>
    );
};

export default AssignForm;